module.exports = __webpack_public_path__ + "static/media/Gilroy-Light.d90fa984.otf";